import { render } from "./RegisterGateway.vue?vue&type=template&id=1a1d5cf9&scoped=true"
import script from "./RegisterGateway.vue?vue&type=script&lang=js"
export * from "./RegisterGateway.vue?vue&type=script&lang=js"

import "./RegisterGateway.vue?vue&type=style&index=0&id=1a1d5cf9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a1d5cf9"]])

export default __exports__